import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { ProductsServices } from '../../../products/services';
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
/**
 * Generated class for the IngredientCompPartialIngSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-providers-partial-products-select',
    templateUrl: 'providers-partial-products-select.html',
})
export class ProvidersPartialProductsSelectPage {

    term: string;
    products: any;
    //datatable
    sorts = [
        { prop: 'name', dir: 'asc' }
    ];
    @ViewChild(DatatableComponent) table: DatatableComponent;
    ColumnMode = ColumnMode;
    config_msg = {
        emptyMessage: this.translate.instant('general-no-hay-datos'),
        totalMessage: this.translate.instant('general-total'),
        selectedMessage: this.translate.instant('general-seleccionado')
    };

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        private toastCtrl: ToastController,
        public productsServices: ProductsServices,
        public globals: Globals,
        public translate: TranslateService) {

        this.initProducts();

    }

    async initProducts() {
        this.productsServices.getPagesProducts('basic', 0);
        this.productsServices.page_active = 1;
    }

    insert(product) {
        if (!this.check(product.UID)) { //Buscamos si el producto ya esta anadido
            var _array = Array();
            _array.push(product.UID);
            _array.push(this.globals.nameLangSelectProduct(product));
            _array.push(product.allergens);
            _array.push(product.providers);
            _array.push(product.price_static || 0);

            this.productsServices.provider_products_array_tmp.push(_array);
            this.productsServices.provider_products_array_tmp = [...this.productsServices.provider_products_array_tmp];

            let toast = this.toastCtrl.create({
                message: this.translate.instant('general-producto') + ' ' + this.globals.nameLangSelectProduct(product) + ' ' + this.translate.instant('instant-anadido-correctemente'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-producto-esta-anadido-lista'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    check(value) {
        var response = false;
        for (var i = 0; i < this.productsServices.provider_products_array_tmp.length; i++) {
            var obj = this.productsServices.provider_products_array_tmp[i];
            if (obj[0] == value) {
                response = true;
            }
        }
        return response;
    }
    nextPage() {
        if (this.productsServices.page_active < this.productsServices.pagesProducts.length) {
            this.productsServices.page_active += 1
        }
        this.productsServices.getListProductsMinMax();
    }
    previusPage() {
        if (this.productsServices.page_active > 1) {
            this.productsServices.page_active -= 1;
        }
        this.productsServices.getListProductsMinMax();
    }
    activePage(number) {
        this.productsServices.page_active = number;
        this.productsServices.getListProductsMinMax();
    }
    clickElement(event) {
        if (event.type == 'click') {
            this.insert(event.row);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/providers/providers-add-select-elements/providers-partial-products-select/providers-partial-products-select.ts